import { create } from 'zustand'
import itemService from '../services/itemService'

const useMarketplaceStore = create((set, get) => ({
    items: [],
    itemDetail: null,
    loading: false,
    error: null,

    // Fetch all items
    fetchItems: async () => {
        set({ loading: true, error: null })
        try {
            const response = await itemService.getItems()
            set({ items: response.data, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    // Fetch item by ID
    fetchItemDetail: async (id) => {
        set({ loading: true, error: null })
        try {
            const response = await itemService.getItemById(id)
            set({ itemDetail: response.data, loading: false })
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    // Create a new item
    createItem: async (itemData) => {
        set({ loading: true, error: null })
        try {
            const response = await itemService.createItem(itemData)
            set((state) => ({
                items: [...state.items, response.data],
                loading: false,
            }))
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    // Update an existing item
    updateItem: async (id, itemData) => {
        set({ loading: true, error: null })
        try {
            const response = await itemService.updateItem(id, itemData)
            set((state) => ({
                items: state.items.map((item) => (item.id === id ? response.data : item)),
                loading: false,
            }))
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    // Delete an item
    deleteItem: async (id) => {
        set({ loading: true, error: null })
        try {
            await itemService.deleteItem(id)
            set((state) => ({
                items: state.items.filter((item) => item.id !== id),
                loading: false,
            }))
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    filters: {
        exterior: ['Any'],
        phase: ['Any'],
        delivery: ['Any'],
    },
    setFilters: (category, value) =>
        set((state) => ({
            filters: {
                ...state.filters,
                [category]: value,
            },
        })),

    searchTerm: '',
    setSearchTerm: (term) => set({ searchTerm: term }),

    minPrice: '',
    setMinPrice: (price) => set({ minPrice: price }),

    maxPrice: '',
    setMaxPrice: (price) => set({ maxPrice: price }),

    sortOrder: '',
    setSortOrder: (order) => set({ sortOrder: order }),

    cart: [],

    addToCart: (item) => {
        set((state) => {
            // TODO: create cart if not exist
        })
    },
}))

export default useMarketplaceStore
